import React, { ComponentProps } from 'react';
import Cropper from 'react-easy-crop';

import { FileWithPreview } from 'src/types/files';

interface ImageCropperProps {
  image: FileWithPreview;
  onCropComplete: ComponentProps<typeof Cropper>['onCropComplete'];
  aspect: number;
}

export const ImageCropper: React.FC<ImageCropperProps> = ({
  image,
  onCropComplete,
  aspect,
}) => {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [zoom, setZoom] = React.useState(1);

  return (
    <div className="w-full h-full">
      <div className="absolute right-0 left-0 top-[55px] bottom-[100px] [&>.reactEasyCrop_Container]:bg-black [&>.reactEasyCrop_Container>.reactEasyCrop_CropArea]:text-[rgba(0,0,0,0.6)]">
        <Cropper
          image={image.preview}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
          classes={{
            containerClassName: 'bg-black',
          }}
        />
      </div>
      <div className="absolute bottom-[52px] left-1/2 w-full -translate-x-1/2 h-[55px] flex items-center">
        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(Number(e.target.value))}
          aria-labelledby="Zoom"
          className="py-4 mx-3.5 w-full h-2 rounded-lg appearance-none cursor-pointer accent-black-heading [&::-webkit-slider-container]:bg-black-heading [&::-webkit-slider-container]:h-[2px] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-black-heading [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-copilot-green-primary [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:cursor-pointer"
        />
      </div>
    </div>
  );
};
